import type { TDataExportValueTypesTimeseriesSection } from 'App/data-export/types/from-code-gen/TDataExportValueTypesTimeseriesSection'
import { translate } from 'i18n/i18n'

export const mapSectionToLabel: Record<TDataExportValueTypesTimeseriesSection, () => string> = {
  crop_development: () => translate.phrases.banyanApp('Crop Development'),
  diseases: () => translate.phrases.banyanApp('Diseases'),
  pests: () => translate.phrases.banyanApp('Pests'),
  water_management: () => translate.phrases.banyanApp('Water Management'),
  weather: () => translate.phrases.banyanApp('Environment'),
}
